import { Link } from 'react-router';
import type { JsonValue, Network } from '../../api/types';
import { strings } from '../../strings';
import { dayWords } from '../entryPoints/helpers';

const a = strings.networks.entryPoints.aws;

/**
 * Feature spec 17, phase 5 (spec 11 6.15 item 33; user decision 2026-11-03): a read-only line in the AWS provider block saying
 * whether the network's AWS Shield Advanced subscription renews, with its date, and linking to Entry points, where the Shield
 * add-on's auto-renew is changed. Nothing while no saved entry point enables Shield Advanced.
 */
export function ShieldRenewalLine({ network }: { network: Network }) {
  const shielded = network.settings.entryPoints.filter((ep) => ep.addOns?.['shield-advanced']?.enabled);
  if (shielded.length === 0) return null;
  const renews = shielded.some((ep) => ep.addOns?.['shield-advanced']?.autoRenew);
  const endsAt = endOf(network.outputs['aws/shield']);
  return (
    <p className="help sm:col-span-2" data-testid="settings-shield-renewal">
      {renews
        ? a.settingsShieldRenews(endsAt ? dayWords(endsAt) : null)
        : a.settingsShieldEnds(endsAt ? dayWords(endsAt) : null)}{' '}
      <Link className="link" to={`/networks/${network.id}?tab=entry-points`}>
        {a.settingsShieldChange}
      </Link>
    </p>
  );
}

function endOf(shield: JsonValue | undefined): string | null {
  if (!shield || typeof shield !== 'object' || Array.isArray(shield)) return null;
  const endsAt = (shield as Record<string, JsonValue>).endsAt;
  return typeof endsAt === 'string' ? endsAt : null;
}
